module.exports = __webpack_public_path__ + "img/53.f10baf30.png";